
import React, { useState, useEffect, useRef, Fragment } from 'react';
import axios from 'axios';
import constants from '../../constants';
import { cookieStorageUtility } from '../../utils/utilityFunctions';
import { checkRole } from '../Common/CheckRole';
import Loader from '../Common/Loader';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const BulkCharge = (props) => {
  const [paymentBulkLogs, setPaymentBulkLogs] = useState([]);
  const [flag, setFlag] = useState(false);
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [showUILoader, setShowUILoader] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [blockChannel, setBlockChannel] = useState(true);
  const [noData, setNoData] = useState(false);
  const [total, setTotal] = useState('');
  const [limit] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);


  useEffect(() => {
      uploadedCSVlist();
    }, [pageNumber]);
  
   const handleFiles = (files) => {
    const _file = files.target.files[0];
    var reader = new FileReader();
    reader.onload = e => {
      // console.log(reader.result);
    };
    reader.readAsText(_file);
    let formData = new FormData();
    formData.append('file', _file);
    setShowUILoader(true);
    axios(serverUrl + 'payment/bulk_reinitiate_charge', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: formData
    })
      .then(response => {
        if (response.data.status === 'success') {
          showMessage('success', response.data.message);
          uploadedCSVlist();
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const showMessage = (type, msg) => {
    setFlag(true);
    setType(type);
    setMessage(msg);
    setTimeout(() => setFlag(false), 5000);
  };

  const downloadSampleFile = () => {
    window.open('/bulk_charge.csv', '_blank')
  };

  const uploadedCSVlist = () => {
    setShowUILoader(true);
    axios(serverUrl + 'payment/bulk_reinitiate_charge_list', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { page: pageNumber, limit: limit }
    })
      .then(response => {
        if (response.data.status === 'success') {
            console.log(response.data.data);
          setPaymentBulkLogs(response.data.data);
          setTotal(response.data.total);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const downloadFile = (fileUrl) => {
    if (!fileUrl) {
      showMessage('error', 'File URL not available');
      return;
    }
    
    // Direct download using anchor tag for S3 URLs
    const link = document.createElement('a');
    link.href = fileUrl;
    
    // Extract filename from URL
    const fileName = fileUrl.split('/').pop().split('?')[0] || 'download.csv';
    link.setAttribute('download', fileName);
    link.setAttribute('target', '_blank');
    
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  const sendEmail = (fileId) => {
    setShowUILoader(true);
    axios(serverUrl + 'payment/send_email', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { file_id: fileId }
    })
      .then(response => {
        if (response.data.status === 'success') {
            showMessage('success', response.data.message);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const renderLogList = () => {
    return paymentBulkLogs.map((val, id) => (
      <div className="table_row border_t_1 border_color_1 text-start" key={id}>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5">
            <div className="ovr fnt12 margtop5" title="Booking ID">
              {val.user}
            </div>
          </div>
        </div>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5">
            <div className="ovr fnt12 margtop5" title="Amount">
              {val.file_name}
            </div>
          </div>
        </div>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5">
            <div className="ovr fnt12 margtop5" title="Status">
              {val.status}
            </div>
          </div>
        </div>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5">
            <div className="ovr fnt12 margtop5" title="PG Message">
              {val.created_at}
            </div>
          </div>
        </div>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5 d-flex" style={{ gap: '10px' }}>
            {/* <div className="ovr fnt12" title="Download File">
              <i className="fa fa-download cursor_p" aria-hidden="true" onClick={() => downloadFile(val.file_url)}></i>            
            </div> */}
            <div className="ovr fnt12" title="Send Email">
              <i className="fa fa-envelope cursor_p" aria-hidden="true" onClick={() => sendEmail(val.id)}></i>            
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const customStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', width: '94vw', flexDirection: 'column', margin: '20px' };

  return (
    <React.Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">Bulk Charge</div>
          </div>
          <div className="col-xs-12 col-md-auto marg_bottom10 place-left">
            <div className="btn1 pad_top_bot7 pad_lft_rht15 cursor_p tc">
              <label htmlFor="bulk-card-upload" style={{ cursor: "pointer" }} onClick={() => downloadSampleFile()}>
                <i className="fa fa-credit-card marg_right7"></i>
                Download Sample File
              </label>
            </div>
          </div>
          <div className="col-xs-12 col-md-auto marg_bottom10 place-right">
            <div className="btn1 pad_top_bot7 pad_lft_rht15 cursor_p tc">
              <label htmlFor="bulk-card-upload" style={{ cursor: "pointer" }}>
                <i className="fa fa-credit-card marg_right7"></i>
                Upload File
              </label>

              <input
                id="bulk-card-upload"
                type="file"
                accept=".csv"
                onChange={handleFiles}
                style={{ display: "none" }}
              />
            </div>
          </div>
        </div>
      </div>
       {flag ? (
        <div className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}>
          {message}
        </div>
      ) : ''}
      <div className="container_fluid pad_lft_rht20 padtop25">
        <div className="cover border_all_1 border_color_1 text-start">
          <div className="scrolly_auto">
            <div className="table_col table_fixed text-start">
              <div className="table_row bg2_8">
                <div className="tabcel align_middle pad10 tu bld wdhpx150">FileName</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Uploaded By</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Status</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Charge DateTime</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Action</div>
              </div>
              {renderLogList()}
              {noData && (
                <div style={customStyle}>
                  <img src="/images/no_result.png" alt="No Logs Found" />
                  <div className="ovr tc fnt16 bld">No Logs Found</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BulkCharge;
